export const ROUTING_ICONS = {
  plane: 'https://cdn.naviparking.com/digital_parking/assets/plane.svg',
  car: 'https://cdn.naviparking.com/digital_parking/assets/car.svg',
  doubleArrow:
    'https://cdn.naviparking.com/digital_parking/assets/double_arrow.svg'
} as const

export type RoutingIconKey = keyof typeof ROUTING_ICONS

export const getRoutingIcon = (iconType: string): string => {
  switch (iconType) {
    case 'car':
      return ROUTING_ICONS.car
    case 'plane':
      return ROUTING_ICONS.plane
    default:
      return ROUTING_ICONS.doubleArrow
  }
}
